/**
 * Created by Christof Sander on 01.07.2016.
 */

module.exports = {
	config: {
		delimiter: ' - ',
		maxNrOfParts: 4,
		maxNumbersPerPart: 4
	},

	model: {
		value: ''
	},

	events: {
		beforeChange: {
			type: 'input',
			action: function(event){
				var self = event.data.component;
				var originalValue = this.value;
				if(self.updateValue(originalValue)){
					this.selectionEnd = self.format(originalValue, this.selectionStart, this.selectionEnd);
				}
			}
		},
		onChange: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.updateValue(self.$.val());
				self.triggerClosest('onChildChanged', {
					fieldCode: self.model.fieldCode,
					value: self.model.value
				});
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.disabled = false;
			this.model.isFilterField = false;
			if((this.formMapping || {}).fieldConfig) {
				this.model.disabled = this.formMapping.fieldConfig.disabled;
				this.model.isFilterField = this.formMapping.fieldConfig.isFilterField;
			}

			this.model.config = this.model.config || {};
			this.model.disabled |= this.model.config.disabled;

			this.model.dataFlag = 'dataTEXT';
			if(this.model.atom.dataType === 'integer'){
				this.model.dataFlag = 'dataINT';
			}

			this.model.delimiterLength = String(this.config.delimiter).length || 0;
			this.model.maxCleanLength = this.config.maxNrOfParts * this.config.maxNumbersPerPart;
			var patternPart = '(\\d{0,' + this.config.maxNumbersPerPart + '})';
			this.model.pattern = '';
			var i;
			for(i = 0; i < this.config.maxNrOfParts; i++){
				this.model.pattern += patternPart;
			}
			this.model.pattern = new RegExp(this.model.pattern + '(.*)');

			var newValue;
			if(this.model.isFilterField){
				newValue = this.model.filterValue;
			} else {
				newValue = this.model[this.model.dataFlag];
			}
			this.updateValue(newValue);
		},

		updateValue: function(value){
			var newValue = String(value).replace(/\D/g, '');
			if(newValue !== this.model.value || String(value).length !== this.model.value.length){
				this.model.value = newValue;
				return true;
			}

			return false;
		},

		format: function(originalValue, selectionStart, selectionEnd){
			// init
			selectionStart = parseInt(selectionStart);
			selectionEnd = parseInt(selectionEnd);
			originalValue = originalValue || '';
			var newSelection = selectionEnd;

			// estimate number of parts
			var nrOfParts = (String(this.model.value).length || 0) / this.config.maxNumbersPerPart;
			if(nrOfParts > parseInt(nrOfParts)) nrOfParts = parseInt(nrOfParts) + 1;
			else 								nrOfParts = parseInt(nrOfParts);
			nrOfParts = Math.min(nrOfParts, this.config.maxNrOfParts);

			// calculate and return new cursor position
			if(selectionStart == selectionEnd){
				selectionStart -= (originalValue.substring(0, selectionStart).match(/\D/g) || []).length || 0;
				newSelection = selectionStart + (parseInt(selectionStart / this.config.maxNumbersPerPart) * this.model.delimiterLength);
				if(this.model.value.length > this.model.maxCleanLength && selectionStart < (this.model.maxCleanLength - 1)) {
					this.updateValue(this.model.value.substring(0, selectionStart) + this.model.value.substring(selectionStart + this.model.value.length - this.model.maxCleanLength));
				}
			}

			// set new value
			if(nrOfParts > 0){
				var replacement = '', n;
				for(n = 0; n < nrOfParts; n++){
					if(n > 0) replacement += this.config.delimiter;
					replacement += '$' + (n + 1);
				}
				var newValue = this.model.value.replace(this.model.pattern, replacement);
				this.$.val(newValue);
			} else if(String(originalValue).length > 0) {
				this.$.val('');
			}

			return newSelection;
		}
	},

	hooks: {
		attach: function($element, options){
			if(this.model.value && !options.refresh){
				this.format();
			}
		}
	}
};
